import BeetAPI from '@boite-beet/api-client'
import mitt from 'mitt'
import { createApp } from 'vue'
import { createGtag } from 'vue-gtag'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { Vue3Mq } from 'vue3-mq'

import App from '@/App.vue'
import GlobalComponents from '@/components/global/index.js'
import langRouter from '@/extensions/langRouter/index.js'
import reveal from '@/extensions/reveal/index.js'
import i18n from '@/i18n/index.js'
import '@/styles/app.scss'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import router from '@/router/index.js'
import store from '@/store/index.js'

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(langRouter, 'fr')
  .use(GlobalComponents)
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })
  .use(reveal)
  .use(Vue3Mq, {
    breakpoints: {
      sm: 566,
      md: 1024,
      lg: 1360,
      xl: 1440,
      desktop: 1600,
    },
  })

const emitter = mitt()
app.provide('emitter', emitter)

app.use(
  createGtag({
    bootstrap: false,
    tagId: import.meta.env.VITE_APP_GTAG_ID,
    pageTracker: { router },
  }),
)

app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_KEY })

app.mount('#app')
